import { render, staticRenderFns } from "./ConfirmBreach.vue?vue&type=template&id=73a729d0&"
import script from "./ConfirmBreach.vue?vue&type=script&lang=js&"
export * from "./ConfirmBreach.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports